export = [
	{
		"star": {
			"fill": {
				"color": "rgba(106,9,251,0.7)"
			},
			"opacity": 1,
			"stroke": {
				"color": "rgba(42,128,244,0.8)",
				"width": 8
			},
			"radius": 14,
			"radius2": 9,
			"points": 10
		},
        "text": {
            "fill": {
                "color": "rgba(255,255,255,1)"
            },
            "stroke": {
                "color": "rgba(0,0,0,1)",
                "width": 2
            },
            "text": "Test",
            "offset-x": 0,
            "offset-y": 20,
            "font": "18px fantasy"
        }
	}
];